import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search, MapPin, Users } from "lucide-react";
import { ProCard } from "@/components/ProCard";
import { Spinner, EmptyState } from "@/components/Loader";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { PRO_TYPES, ACCOUNT_LABEL, isListedPro } from "@/lib/constants";

const FILTERS = ["all", ...PRO_TYPES, "STUDENT"];

export default function Discover() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [city, setCity] = useState("");
  const type = params.get("type") || "all";
  const [pros, setPros] = useState(null);

  useEffect(() => {
    setQ(params.get("q") || "");
  }, [params]);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/users", { params: { search: q || undefined, city: city || undefined, account_type: type === "all" ? undefined : type } })
        .then(({ data }) => setPros(data.filter(isListedPro)))
        .catch(() => setPros([]));
    }, 250);
    return () => clearTimeout(t);
  }, [q, city, type]);

  const pick = (p) => {
    const next = new URLSearchParams(params);
    if (p === "all") next.delete("type"); else next.set("type", p);
    setParams(next);
  };

  return (
    <div className="mx-auto max-w-6xl">
      <p className="tm-eyebrow">Discover</p>
      <h1 className="mt-2 font-display text-2xl font-extrabold text-tm-green sm:text-3xl">Find the right tax professional</h1>
      <div className="mt-6 grid gap-3 md:grid-cols-[1fr_260px]">
        <div className="relative"><Search className="absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name, firm or service" className="h-12 rounded-full bg-white pl-10" data-testid="discover-search-input" /></div>
        <div className="relative"><MapPin className="absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input value={city} onChange={(e) => setCity(e.target.value)} placeholder="City" className="h-12 rounded-full bg-white pl-10" data-testid="discover-city-input" /></div>
      </div>
      <div className="no-scrollbar mt-4 flex gap-2 overflow-x-auto pb-1">
        {FILTERS.map((p) => (
          <button key={p} onClick={() => pick(p)} data-testid={`discover-filter-${p.toLowerCase()}`}
            className={`shrink-0 rounded-full px-4 py-2 text-sm font-medium transition-colors duration-200 ${type === p ? "bg-tm-green text-white" : "bg-white border text-slate-700 hover:border-tm-gold"}`}>
            {p === "all" ? "All" : ACCOUNT_LABEL[p]}
          </button>
        ))}
      </div>
      <div className="mt-8">
        {pros === null ? <Spinner /> : pros.length === 0 ? (
          <EmptyState icon={Users} title="No professionals found" text="Try a different search or city." testid="discover-empty" />
        ) : (
          <>
            <p className="mb-4 text-sm text-slate-500" data-testid="discover-result-count">{pros.length} members</p>
            <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">{pros.map((p) => <ProCard key={p.id} pro={p} />)}</div>
          </>
        )}
      </div>
    </div>
  );
}
